<template>
<slide-transition>
<v-container light>
  <v-flex column>
      <v-layout row justify-center style="margin-top:5px;" mb-3>
        <img :src="require('@/assets/images/logo.png')" height="160" style="margin-top:8px;"/>
      </v-layout>
      <v-layout row justify-center style="margin-top:5px;" mb-2>
        <span class="grey--text headline proxima-semi" xs2  style="text-transform: uppercase;">{{ $t('reestablecerContraseña') }}</span>
      </v-layout>
    </v-flex>

    <v-layout justify-center mb-3>
      <span class="reddy--text title" xs2 >{{ $t('introducirEmail') }}</span>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs4 x4 justify-center>
        <v-card style="padding:20px">
          <v-form v-model="valid" id="valid">
            <v-text-field
              v-model="usermail" id="usermail"
              :name="usermail"
              :rules="usermailRules"
              :label="$t('correoElectronico')"
              required
            ></v-text-field>
            <v-layout justify-center style="padding-top:30px">
              <v-btn :disabled="!valid || desactivarBoton" :loading="desactivarBoton" color="primary" @click="resetPassword()">
                {{ $t('reestablecerContraseña') }}
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</slide-transition>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      usermail: '',
      valid: false,
      usermailRules: [
        (v) => !!v || this.$t('rules.obligatorio'),
        (v) => /^\w+([+.-]?\w+)*@\w+([+.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('rules.email')
      ],
      desactivarBoton: false
    }
  },
  methods: {
    ...mapActions({
      resetPasswordApi: 'login/resetPassword',
      addAlert: 'alerts/add'
    }),
    resetPassword () {
      this.desactivarBoton = true
      this.resetPasswordApi({
        usermail: this.usermail
      })
        .then(() => {
          this.addAlert({texto: this.$t('recibiContraseñaViaEmail'), color: 'success'})
          this.$router.push({
            name: 'login'
          })
          this.desactivarBoton = false
        })
        .catch((error) => {
          this.desactivarBoton = false
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
        })
    }
  }
}
</script>
